import { Injectable } from '@angular/core';
import { HttpService } from 'app/resources/services/http.service';
import { Router } from '@angular/router';
import { ValePresenteCestaService } from 'app/resources/services/vale-presente-cesta-service.service';

@Injectable()
export class ValePresenteService {
  public processando = false;
  public pedidos: Array<any>;
  public pedido: any = undefined;
  public parceiro: any = undefined;
  public parceiroVitrine: any = undefined;
  public valePresente: any = undefined;
  public itens: Array<any> = undefined;
  public totalItens: number | string = undefined;
  public valorTotal: number | string = undefined;
  public pontosTotais: number | string = undefined;
  public quantidade = 1;
  public cep = '';
  public fretes: Array<any> = undefined;
  public ep = '';
  public logradouroIsReadOnly = true;
  public bairroIsReadOnly = true;
  public pedidoComValeFisico = false;
  public processandoCalcularFrete: boolean;


  constructor(private http: HttpService, public router: Router,
    private valePresenteCestaService: ValePresenteCestaService) { }

  public novo() {
    this.valePresenteCestaService.clean();
    this.router.navigate(['/valepresente/parceiros']);
  };

  public verificarValeFisico() {
    const itens = this.valePresenteCestaService.itens;
    this.pedidoComValeFisico = false;
    for (let i = 0; i < itens.length; i++) {
      if (!itens[i].valePresente.virtual) {
        this.pedidoComValeFisico = true;
        break;
      }
    }
  }

  public calculaTotais() {
    this.itens = this.valePresenteCestaService.itens;
    this.totalItens = this.valePresenteCestaService.totalItens();
    this.valorTotal = this.valePresenteCestaService.valorTotal();
    this.pontosTotais = this.valePresenteCestaService.pontosTotais();
  }

  public fillPedidos() {
    this.processando = true;
    this.pedidos = undefined;

    this.http.pathRest().get('valepresente/pedidos/', true)
      .subscribe(
      sucesso => {
        this.pedidos = sucesso.json();
        this.processando = false;
      }, erro => {

      });
  }

  public visualizarPedido(pedido) {
    this.pedido = pedido;
    this.pedido.itens = [];
    this.router.navigate(['/valepresente/pedido']);

    if (this.pedido.frete.tipo === 'gratuito') {
      this.pedido.frete.tipoDescricao = 'Gratuito';
    } else if (this.pedido.frete.tipo === 'sedex') {
      this.pedido.frete.tipoDescricao = 'Sedex';
    } else if (this.pedido.frete.tipo === 'sedex_10') {
      this.pedido.frete.tipoDescricao = 'Sedex 10';
    } else if (this.pedido.frete.tipo === 'pac_varejo') {
      this.pedido.frete.tipoDescricao = 'PAC';
    } else {
      this.pedido.frete.tipoDescricao = '';
    }

    this.http.pathRest().get('valepresente/pedidos/' + pedido.id + '/' + pedido.uuid + '/itens/', true)
      .subscribe(
      sucesso => {
        this.pedido.itens = sucesso.json();
      });
  }

  public visualizarVitrine(parceiro) {
    this.processando = true;
    this.parceiro = parceiro;

    this.http.pathRest().get('valepresente/parceiro/' + parceiro.id + '/' + parceiro.uuid + '/valepresente/vitrine/', true)
      .subscribe(
      sucesso => {
        this.parceiroVitrine = sucesso.json();
        for (let i = 0; i < this.parceiroVitrine.length; i++) {
          this.parceiroVitrine[i].isVariavel = (this.parceiroVitrine[i].valor === 0);
        }

        this.processando = false;
      });

    this.router.navigate(['/valepresente/vitrine']);
  }

}



// WEBPACK FOOTER //
// ./src/app/resources/services/vale-presente.service.ts